<template>
    <v-flex class="ypo-speakers">
        <h2 class="ypo-speakers__title">{{checkCFF ? SpeakerApplicants.YPO_FACILITATORS : SpeakerApplicants.YPO_SPEAKERS}}</h2>
        <v-layout
            row
            wrap
            class="ypo-speakers__find-speaker relative-position">
            <v-flex xs12 lg4>
                <strong v-if="checkCFF">{{SpeakerApplicants.FIND_A_CFF_BY_NAME}}
                    <i @mouseover="showTooltipForCFF = true" @mouseout="showTooltipForCFF = false" class="fas fa-info-circle">
                    </i></strong>
                <strong v-else>{{SpeakerApplicants.FIND_A_SPEAKER_BY_NAME}}
                    <i @mouseover="showTooltip = true" @mouseout="showTooltip = false" class="fas fa-info-circle">
                    </i></strong>
                <small v-if="!checkCFF" v-html="SpeakerApplicants.YPO_GUIDES"></small>
                <v-flex v-if="showTooltip" class="find-speaker-tooltip">
                    <span>{{SpeakerApplicants.TOOLTIP_FOR_FIND_SPEAKER_BY_NAME}}
                    </span>
                </v-flex>
                <v-flex v-if="showTooltipForCFF" class="find-speaker-tooltip">
                    <span>{{SpeakerApplicants.TOOLTIP_FOR_CFF}}</span>
                </v-flex>
            </v-flex>
            <v-flex
                xs12
                lg8
                class="speaker-actions-main"
                text-sm-right>
                <v-btn @click="handleResourceDirectoryNav" class="small speaker-actions-main__button speaker-actions-main__button--resource">
                  {{resourceDirectoryText}}
                </v-btn>            
                <v-btn class="cff_btn small speaker-actions-main__button speaker-actions-main__button--speaker"
                       v-if="checkCFF"
                       @click="becomeACFFRedirect">
                      {{speakerRegistrationConstants.BECOME_A_CFF}}
                    </v-btn>               
            </v-flex>
            <v-flex xs12>
              <SearchSpeakerAutoComplete :checkCFF="checkCFF"></SearchSpeakerAutoComplete>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex
                xs12
                md3
                class="refine-list">
                <v-layout class="refine-list__title">
                    <v-flex>
                        <strong>{{SpeakerApplicants.REFINE_LIST}} <i @mouseover="showRefineListTooltip = true" @mouseout="showRefineListTooltip = false" class="fas fa-info-circle">
                            </i></strong>
                        <v-flex v-if="showRefineListTooltip" class="find-speaker-tooltip">
                            <span>{{SpeakerApplicants.USE_BELOW_TOOLS_NARROW_RESULTS}}</span>
                        </v-flex>
                        <v-btn class="reset primary_btn" @click="resetSearch()"><i class="fas fa-redo"></i> {{SpeakerApplicants.RESET}} </v-btn>
                    </v-flex>
                    <v-flex v-if="totalResultCount !== ''" text-xs-right>
                        <span class="results">{{totalResultCount}} Results</span>
                    </v-flex>
                </v-layout>
                <SearchSpeakerRegion v-if="checkCFF" :applySpeakerFilter="applySpeakerFilter"></SearchSpeakerRegion>
                <SearchSpeakersWhoAre :applySpeakerFilter="applySpeakerFilter"></SearchSpeakersWhoAre>
                <SearchSpeakersFeeRange v-if="!checkCFF" :applySpeakerFilter="applySpeakerFilter"></SearchSpeakersFeeRange>
                <SearchSpeakerCffFee v-if="checkCFF" :applySpeakerFilter="applySpeakerFilter"></SearchSpeakerCffFee>
                <SearchSpeakersTravelsFrom :applySpeakerFilter="applySpeakerFilter" :countries="speakerList && speakerList.countries ? speakerList.countries : []"></SearchSpeakersTravelsFrom>
                <SearchSpeakersTopics :applySpeakerFilter="applySpeakerFilter"></SearchSpeakersTopics>
            </v-flex>
            <v-flex
                xs12
                md9
                class="speakers-list">
                <v-layout
                    row
                    wrap
                    class="speakers-list__sorting" :id="`speaker-sorting-option`">
                    <v-flex                             
                        xs8
                        sm7
                        md6
                        lg8>
                    </v-flex>
                    <v-flex
                        xs12
                        sm5
                        md6
                        lg4
                        class="sort-options">
                        <label>Sort by</label>
                        <v-select
                            :items="SpeakerApplicants.SORT_OPTIONS"
                            solo
                            attach
                            flat
                            v-model="speakerOrderBy"
                            @change="onOrderByChange()"
                            hide-details></v-select>
                    </v-flex>
                </v-layout>
                <div
                    class="speakers-list-items"
                    v-infinite-scroll="getInfiniteSearchSpeakers"
                    :infinite-scroll-distance="2000">
                    <status-overlay
                        v-if="!speakerList.searchResults"
                        :action="getSpeakersAction"
                        class="speakers-list-items__overlay"></status-overlay>
                    <v-layout
                        id="filter-results"
                        row
                        wrap
                        v-if="speakerList">
                        <v-flex
                            xs12
                            sm4
                            v-for="(Speakers, i) in speakerList.searchResults"
                            :key="i">
                            <v-card class="panelBlock speakers-list__row">

                                <v-flex @click="openSpeakerProfilePage(Speakers, $router, $route.query)">
                                    <figure>
                                        <img :src="Speakers.profileImageUrl" :onerror="imageErrorFallback(Speakers.fallbackProfileImageUrl)" :data-qe-id='!checkCFF ? `"speaker_profile_img_${i}"` : `"CFF_profile_img_${i}"`'/>

                                        <small v-if="!Speakers.recordTypeName.toLowerCase().includes('speaker')" data-v-7e20760a="">{{Speakers.recordTypeName}}</small>
                                    </figure>
                                    <v-flex pt-2>
                                        <v-flex class="user-info">
                                            <strong>{{Speakers.preferredName ? Speakers.preferredName : Speakers.firstName}} {{Speakers.lastName}}</strong>
                                            <small>{{Speakers.primaryChapter}}</small>
                                            <span>{{Speakers.title}}</span>
                                            <!-- <p>Peak Performance, Motivation & Sales Strategist</p> -->
                                            <label>More About Me </label>
                                        </v-flex>
                                    </v-flex>

                                    <v-flex
                                        mt-3
                                        class="topics"
                                        v-if="Speakers.topics.length> 0">
                                        <strong>Topics</strong>
                                        <v-chip v-for="(topic, j) in Speakers.topics.slice(0,3)" :key="j">{{topic}}</v-chip>
                                        <em v-if="Speakers.topics.length > 3">+ {{Speakers.topics.length - 3}} MORE</em>
                                    </v-flex>

                                    <v-flex class="footer">
                                        <v-flex class="footer__row">
                                            <span  v-if="checkCFF && (Speakers.forumTrainingMinFee || Speakers.forumTrainingMaxFee)">
                                              <i class="fas fa-dollar-sign"></i>{{ getCffFeeRange(Speakers )}}
                                            </span>
                                            <span v-if="!checkCFF"><i class="fas fa-dollar-sign"></i> {{Speakers.fees}}</span>
                                            <span><i class="fas fa-plane"></i> Travels From: <small>{{Speakers.travelsFromCity}} , {{Speakers.country}}</small></span>
                                        </v-flex>
                                    </v-flex>
                                </v-flex>
                                <v-flex class="footer__social">
                                    <a :class="Speakers.primaryPhoneNumber ? '' : 'disabled-item'" slot="activator" :href="`tel:${PhoneNumberFormat(Speakers.primaryPhoneCode, Speakers.primaryPhoneNumber)} ${ memberDirectoryPageConstant.label.PHONE_EXTENSION}`" :data-qe-id='!checkCFF ? `"speaker-profile_country-code_${i}"` : `"CFF-profile_country-code_${i}"`'>

                                        <i class="fas fa-phone">
                                        </i> </a>
                                    <a :class="Speakers.primaryEmail ? '' : 'disabled-item'" @click="launchEmailClient(Speakers.primaryEmail)" :data-qe-id='!checkCFF ? `"speaker-profile_email-id_${i}"` : `"CFF-profile_email-id_${i}"`'>
                                        <i class="material-icons email-icon">email
                                        </i> </a>
                                </v-flex>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </div>

                <v-flex class="ypo-speakers__spelled" v-if="speakerList && speakerList.searchResults && speakerList.searchResults.length === 0">
                    <strong class="mb-2">{{SpeakerApplicants.ZERO_SEARCH_RESULTS}}</strong>
                    <span> {{SpeakerApplicants.NO_SEARCH_RESULTS_MESSAGE}}</span>
                </v-flex>
            </v-flex>
        </v-layout>
        <BackToTop></BackToTop>
    </v-flex>
</template>

<script>
    import SpeakerAdminstration from "../ResourceDirectory/SpeakerAdministration";
    import { mapActions, mapGetters, mapState } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { speakerRegistrationConstants, SpeakerApplicants, openSpeakerProfilePage, speakerSearchConstants } from "../Speakers/speakerConstant";
    import SearchSpeakersTopics from "./SearchSpeakerTopics";
    import SearchSpeakersFeeRange from "./SearchSpeakerFeeRange";
    import SearchSpeakersTravelsFrom from "./SearchSpeakerTravelsFrom";
    import SearchSpeakersWhoAre from "./SearchSpeakerWhoAre";
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';
    import { imageErrorFallback } from "../../common/utils/utils";
    import SearchSpeakerAutoComplete from "./SearchSpeakerAutoComplete.vue";
    import BackToTop from '../../components/Layout/BackToTop';
    import { memberDirectoryPageConstant } from "../MemberDirectoryPage/memberDirectoryPage.constants";
    import union from 'lodash/union';
    import SearchSpeakerRegion from "./SearchSpeakerRegion";
    import SearchSpeakerCffFee from "./SearchSpeakerCffFee";
    import { commonEnvVariables } from "@/commonEnvVariables";

    export default {
        name: "SearchSpeakers",
        data: () => ({
            orderBy: 'LastName',
            totalResultCount: '',
            SpeakerApplicants,
            speakerRegistrationConstants,
            speakerSearchConstants,
            showTooltip: false,
            memberDirectoryPageConstant,
            showTooltipForCFF: false,
            showRefineListTooltip: false,
            searchFilters: [],
            nextSSPageSkip: 0,
            disableSSInfiniteScroll: false,
            noMoreSSToFetch: false,
            speakerList: [],
        }),
        components: {
            SearchSpeakerAutoComplete,
            SpeakerAdminstration,
            SearchSpeakersTopics,
            SearchSpeakersFeeRange,
            SearchSpeakersTravelsFrom,
            SearchSpeakersWhoAre,
            StatusOverlay,
            BackToTop,
            SearchSpeakerRegion,
            SearchSpeakerCffFee,
        },
        created() {
            this.orderBy = this.$route.query.orderBy || 'LastName';
            sessionStorage.setItem(SpeakerApplicants.PREVIOUS_PAGE, 'SearchSpeaker');
        },
        methods: {
            ...mapActions({
                getYPOSpeakers: `searchSpeaker/${storeAction.getYPOSpeakers}`,
            }),
            applySpeakerFilter(filters) {
                this.searchFilters = [...this.searchFilters, ...filters];
            },
            openSpeakerProfilePage,
            imageErrorFallback,
            PhoneNumberFormat(countryCode, phoneNumber) {
                if (phoneNumber) {
                    if (countryCode && phoneNumber.length >= 3) {
                        return `+${countryCode} ${phoneNumber.substring(0, 3)} ${phoneNumber.substring(3, 6)} ${phoneNumber.substring(6, phoneNumber.length)}`;
                    } else if (phoneNumber.length >= 3) {
                        return `${phoneNumber.substring(0, 3)} ${phoneNumber.substring(3, 6)} ${phoneNumber.substring(6, phoneNumber.length)}`;
                    }
                }
            },
            resetSearch() {
                if (this.checkCFF) {
                    this.$router.push({
                        query: { speakersWhoAre: this.SpeakerApplicants.IS_CFF_SPEAKER },
                    });
                } else {
                    this.$router.push({
                        query: {},
                    });
                }
            },
            onOrderByChange() {
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        orderBy: this.orderBy,
                    },
                });
            },
            getInfiniteSearchSpeakers() {
                if (!this.disableSSInfiniteScroll && !this.noMoreSSToFetch) {
                    this.disableSSInfiniteScroll = true;
                    this.getYPOSpeakers({
                        searchText: this.$route.query.speakerSearchText,
                        orderBy: this.orderBy,
                        searchFilters: this.searchFilters,
                        nextSSPageSkip: this.nextSSPageSkip,
                    }).then((data) => {
                        if ((this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) &&
                         this.nextSSPageSkip === 0 && 
                         ((!this.checkCFF && Object.keys(this.$route.query).length > 0) || (this.checkCFF && ((this.$route.query.speakersWhoAre === 'IsCFFSpeaker' && Object.keys(this.$route.query).length > 1) || (this.$route.query.speakersWhoAre !== 'IsCFFSpeaker' && Object.keys(this.$route.query).length > 0))))) {
                            this.$vuetify.goTo(`#speaker-sorting-option`, { offset: 50 });
                        }
                        if (!data.searchResults.length || data.searchResults.length < this.speakerSearchConstants.RESULTS_PER_PAGE) {
                            this.noMoreSSToFetch = true;
                        }
                        this.setYPOSpeakers(data);
                        this.totalResultCount = data.totalResultCount;
                    }).catch(() => {
                        this.setYPOSpeakers([]);
                    }).finally(() => {
                        this.disableSSInfiniteScroll = false;
                    });
                }
            },
            setYPOSpeakers(data) {
                if (data && data.searchResults) {
                    data.searchResults.forEach((item) => {
                        item.profileImageUrl = `${item.profileImageUrl}?${new Date().getTime()}`;
                    });
                }
                if (this.speakerList && this.speakerList.searchResults && this.speakerList.searchResults.length) {
                    let newItemPaused = false;
                    data.searchResults.forEach((item) => {
                        const alreadyExist = this.speakerList.searchResults.some(it => it.id === item.id);
                        if (!alreadyExist) {
                            this.speakerList.searchResults.push(item);
                            newItemPaused = true;
                        }
                    });
                    if (newItemPaused) {
                        this.nextSSPageSkip += 1;
                    }
                    this.speakerList.countries = union(this.speakerList.countries, data.countries);
                } else {
                    this.nextSSPageSkip += 1;
                    this.speakerList = data;
                }
            },
            launchEmailClient(email) {
                window.location = `mailto:${email}`;
            },
            openSpeakerAdminstrationPage(path, query) {
                this.$router.push({
                    path,
                    query,
                });
            },
            getCffFeeRange(speakerData) {
              return `YPO Forum Training: ${this.getNumberInFormat(speakerData.forumTrainingMinFee || 0)}
              - ${this.getNumberInFormat(speakerData.forumTrainingMaxFee)}`;
            },
            getNumberInFormat(fee) {
              return `USD ${fee.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
            },
            becomeACFFRedirect() {
              const envVariables = commonEnvVariables();
              const target = this.isMobileAppBrowser ? '_self' : '_blank';
              window.open(envVariables.BECOME_A_CFF, target);
            },      
            handleResourceDirectoryNav() {
              const envVariables = commonEnvVariables();
              const target = this.isMobileAppBrowser ? '_self' : '_blank';
              window.open(envVariables.SPEAKER_SEARCH, target);
           },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                speakerRegistrationStatus: `speaker/${storeGetters.speakerRegistrationStatus}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
            speakerOrderBy: {
                get() {
                    return this.SpeakerApplicants.SORT_KEY_TO_LANGUAGE_CONVERTER[this.orderBy];
                },
                set(value) {
                    this.orderBy = this.SpeakerApplicants.SORT_LANGUAGE_TO_KEY_CONVERTER[value];
                },
            },
            showBecomeSpeaker() {
                return this.speakerRegistrationStatus === "" || this.speakerRegistrationStatus === 'R';
            },
            checkCFF() {
                return !!(this.$route.query.speakersWhoAre && this.$route.query.speakersWhoAre.includes(this.SpeakerApplicants.IS_CFF_SPEAKER));
            },
            getSpeakersAction() {
                return this.actions[storeAction.getYPOSpeakers] || { pending: true };
            },
            resourceDirectoryText() {
                return this.checkCFF ? speakerSearchConstants.VIEW_SPEAKER_RESOURCE_DIRECTORY : speakerSearchConstants.VIEW_CFF_RESOURCE_DIRECTORY;
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .ypo-speakers {
        margin: 90px 30px 0;

        &__title {
            color: $ypo-blue;
            font-family: 'Raleway', sans-serif;
            font-size: 30px;
            font-weight: 500;
            line-height: normal;
        }

        &__find-speaker {
            align-items: flex-end;
            position: relative;

            strong {
                color: $ypo-blue;
                display: block;
            }

            small {
                color: $ypo-cta;
                font-size: 12px;

                a {
                    color: $ypo-cta;
                    font-weight: 600;
                    white-space: nowrap;
                }
            }

            i {
                color: $ypo-cta;
            }

            .v-btn {
               // margin: 0;
            }
            
            .view-speaker {
                color: $ypo-cta;
                font-size: 12px;
                font-weight: 600;
                text-decoration: none;
                text-transform: uppercase;
                margin-right: 4px;
                margin-left: 4px;
                margin-top: 8px;
                margin-bottom: 8px;       
            }
            .form-control {
                position: relative;
                margin-top: 10px;

                .search-btn {
                    position: absolute;
                    right: 20px;
                    top: 9px;
                    margin: 0;

                    i {
                        font-size: 18px;
                        position: relative;
                        right: 20px;
                        top: 4px;
                        cursor: pointer;
                    }
                }
            }

            .find-speaker-result {
                background-color: $white;
                min-width: 500px;
                max-width: 500px;
                min-height: 50px;
                position: absolute;
                box-shadow: 0 4px 14px 0 rgba($black, 0.18);
                border: 1px solid $ypo-tile-border;
                top: 58px;
                left: 0;
                border-radius: 3px;
                z-index: 1;

                &__list {
                    z-index: 2;
                    position: relative;
                    padding-left: 100px;
                    min-height: 85px;
                    border-bottom: 1px solid rgba($ypo-dark-background-gray, 0.1);
                    padding: 10px 10px 10px 85px;
                    line-height: normal;
                    cursor: pointer;
                    transition: all 0.3s ease;

                    &:hover {
                        background-color: rgba($ypo-dark-background-gray, 0.1);
                    }

                    img {
                        position: absolute;
                        width: 65px;
                        height: 65px;
                        left: 10px;
                        border: 1px solid rgba($ypo-dark-background-gray, 0.1);
                    }

                    span {
                        display: block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 16px;
                    }

                    strong {
                        display: block;
                        color: $ypo-dark-background-gray;
                        font-size: 12px;
                        margin-top: 3px;
                    }

                    small {
                        font-size: 14px;
                        margin-top: 3px;
                        display: block;
                    }
                }

                &__no-result {
                    padding: 10px;
                    min-height: 60px;
                    text-align: center;
                    font-weight: 600;

                    span {
                        font-size: 12px;
                        color: $ypo-dark-background-gray;
                        display: block;
                        margin-top: 10px;
                        white-space: normal;
                    }
                }

                &__see-all {
                    display: block;
                    text-align: right;
                    padding: 15px 10px 15px;
                    cursor: pointer;
                    font-weight: 600;
                    color: $ypo-cta;
                    text-transform: uppercase;
                    position: relative;
                    z-index: 2;
                    transition: all 0.3s ease;

                    &:hover {
                        background-color: rgba($ypo-dark-background-gray, 0.1);
                    }
                }

                .custom-popover__bg {
                    &:after {
                        background-color: transparent;
                    }

                }
            }
        }
        
      .speaker-actions-main {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;

        @include breakpointMin(sm) {
          flex-direction: row;
          justify-content: flex-start;
        }

        @include breakpointMin(md) {
          flex-direction: row;
          justify-content: flex-start;
        }
        @include breakpointMin(lg) {
          justify-content: flex-end;
        }

        &__button {
          margin: 10px 0 0 0 !important;
          max-width: 258px;
          font-size: 12px;

          @include breakpointMin(md) {
            font-size: 14px;
            flex-basis: auto;
          }

          &--forum {
            margin-right: 20px !important;
          }
          &--resource {
            margin-right: 20px !important;
            background-color: transparent !important;
            box-shadow: none !important;
            color: $ypo-cta;
            font-weight: 600;
            border: none;
          }
        }
      }

      .speaker-actions-main {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;

        @include breakpointMin(sm) {
          flex-direction: row;
          justify-content: flex-start;
        }

        @include breakpointMin(md) {
          flex-direction: row;
          justify-content: flex-start;
        }
        @include breakpointMin(lg) {
          justify-content: flex-end;
        }

        &__button {
          margin: 10px 0 0 0 !important;
          max-width: 258px;
          font-size: 12px;

          @include breakpointMin(md) {
            font-size: 14px;
            flex-basis: auto;
          }

          &--forum {
            margin-right: 20px !important;
          }
          &--resource {
            margin-right: 20px !important;
            background-color: transparent !important;
            box-shadow: none !important;
            color: $ypo-cta;
            font-weight: 600;
            border: none;
          }
        }

      }

      .cff_fee_range {
        font-size: 12px;
        &__title {
          font-weight: 600;
        }

      }

        .refine-list {
            margin-top: 20px;
            padding-right: 10px;

            h4 {
                font-size: 14px;
                color: $ypo-dark-background-gray;
                font-weight: 600;
                padding: 20px 0;
                border-top: 1px solid $ypo-tile-border;
            }

            &__title {
                padding-bottom: 10px;
                line-height: normal;
                align-items: flex-end;
                position: relative;

                strong {
                    color: $ypo-blue;
                    font-weight: 600;
                    text-transform: uppercase;
                    display: block;

                    i {
                        color: $ypo-cta;
                    }
                }

                small {
                    display: block;
                    margin-top: 5px;
                }

                .reset {
                    color: $ypo-cta;
                    cursor: pointer;
                    border-radius: 50px;
                    padding: 3px 15px 2px;
                    font-size: 12px;
                    box-shadow: inherit;
                    height: auto;
                    font-weight: 500;
                    margin: 10px 0 0 0;
                    min-width: inherit;

                    i {
                        transform: scaleX(-1);
                        margin-right: 3px;
                        font-size: 11px;
                    }
                }

                .results {
                    font-weight: 600;
                    color: $ypo-cta;
                    font-size: 14px;
                }

                .find-speaker-tooltip {
                    left: 84px;
                    top: 17px;

                    @include breakpoint(xs) {
                        left: 10px;
                        top: 18px;
                    }
                }
            }

            .show-speakers {
                &__list {
                    position: relative;
                    padding: 8px 60px 8px 0;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;

                    label {
                        color: $ypo-cta !important;
                        font-weight: 600;
                        font-size: 12px;
                    }

                    .v-input {
                        position: absolute;
                        right: 0;
                        top: 8px;
                        margin-top: 0;
                    }

                    .member-type {
                        background-color: rgba($ypo-medium-gray, 0.2);
                        padding: 10px 10px 5px 10px;
                        margin-top: 15px;
                        box-shadow: 0 1px 3px 0 rgba($black, 0.18);
                        margin-left: 10px;

                        label {
                            white-space: normal;
                            font-weight: 500;
                        }

                        .v-input {
                            position: relative;
                            top: inherit;
                            margin-bottom: 10px;

                            .v-input__slot {
                                align-items: inherit;
                            }

                            .v-icon {
                                font-size: 22px;
                            }
                        }

                        .v-input--is-label-active {
                            label {
                                font-weight: 600;
                            }
                        }
                    }

                    &.interested-trp {
                        overflow: inherit;

                        .find-speaker-tooltip {
                            left: 128px;
                            top: 26px;
                            white-space: normal;

                            @include breakpoint(xs) {
                                left: 50px;
                            }
                        }
                    }
                }
            }

            .speaker-administration {
                margin-top: 30px;

                &__row {
                    border-bottom: 1px solid rgba($ypo-gray, 0.4);
                    padding: 15px;
                    position: relative;
                    color: $ypo-blue;
                    cursor: pointer;
                    transition: all .3s ease;

                    &:hover {
                        background: rgba($ypo-gray, 0.1);
                        text-shadow: 0 1px $ypo-blue;
                    }

                    i {
                        font-size: 20px;
                        margin-right: 5px;
                    }
                }
            }

            &__administration {
                .list-items {
                    border-bottom: 1px solid rgba($ypo-gray, 0.4);
                    padding: 15px;
                    position: relative;
                    color: $ypo-blue;
                    cursor: pointer;
                    transition: all .3s ease;

                    i {
                        font-size: 20px;
                        margin-right: 5px;
                    }

                    &:hover {
                        background: rgba($ypo-gray, 0.1);
                        text-shadow: 0 1px $ypo-blue;
                    }
                }
            }
        }

        .speakers-list {
            margin-top: 14px;

            .speakers-list-items {
                position: relative;

                &__overlay {
                    .overlay__content {
                        height: auto;
                        min-height: 200px;
                    }
                }
            }

            &__sorting {
                align-items: center;
                padding-left: 8px;

                .sort-options {
                    position: relative;
                    padding-left: 98px;

                    label {
                        position: absolute;
                        left: 45px;
                        z-index: 1;
                        top: 13px;
                    }

                    .v-input {
                        font-size: 14px;
                        width: 224px;

                        .v-input__slot {
                            background-color: transparent;
                            padding: 0;

                            .v-select__selections,
                            .v-icon {
                                color: $ypo-cta !important;
                            }
                        }

                    }

                    .v-menu__content {
                        top: 40px !important;
                        min-width: 250px !important;
                        right: 0;
                        left: inherit !important;

                        .primary--text {
                            .v-list__tile {
                                color: rgba($black, 0.8) !important;
                            }
                        }

                    }

                    .v-input__prepend-outer {
                        position: absolute;
                        right: 28px;

                        i {
                            font-size: 14px;
                            color: $ypo-cta;
                        }
                    }

                }
            }

            .panelBlock {
                padding: 15px;
                transition: all 1s ease;
                margin: 10px;
                cursor: pointer;

                &:hover {
                    background-color: rgba($ypo-gray, 0.3);
                }
            }

            &__row {
                figure {
                    height: 270px;
                    position: relative;
                    background: rgba($ypo-gray, 0.18);
                    justify-content: center;
                    display: flex;

                    img {
                        max-width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    small {
                        position: absolute;
                        background-color: $ypo-dark-green;
                        bottom: 0;
                        font-size: 12px;
                        font-weight: 600;
                        text-transform: uppercase;
                        color: white;
                        left: 0;
                        width: 100%;
                        text-align: center;
                        padding: 2px;
                    }
                }

                .user-info {
                    min-height: 110px;

                    strong {
                        font-size: 18px;
                        color: $ypo-blue;
                        font-weight: 600;
                        display: block;
                        word-break: break-word;
                        line-height: normal;
                    }

                    small {
                        display: block;
                        font-size: 12px;
                        font-weight: 600;
                        color: $ypo-cta;
                    }

                    span {
                        font-size: 14px;
                        margin-top: 5px;
                        display: block;
                    }

                    p {
                        font-size: 14px;
                        margin: 10px 0 0;
                        padding: 0;
                        min-height: 50px;
                    }

                    label {
                        text-decoration: none;
                        color: $ypo-cta;
                        font-weight: 600;
                        text-transform: uppercase;
                        display: block;
                        line-height: normal;
                        font-size: 12px;
                        cursor: pointer;
                    }
                }

                .topics {
                    min-height: 140px;
                    border-bottom: 1px solid $ypo-tile-border;
                    padding-bottom: 10px;

                    strong {
                        color: $ypo-blue;
                        font-size: 12px;
                        font-weight: 600;
                        text-transform: uppercase;
                        display: block;
                        margin-bottom: 5px;
                    }

                    span {
                        color: $ypo-cta;
                        font-size: 10px;
                        font-weight: 600;
                        cursor: pointer;
                        display: inline-block;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        max-width: 100%;
                    }
                }

                .footer {
                    &__row {
                        padding: 10px 0;
                        border-bottom: 1px solid $ypo-tile-border;

                        span {
                            display: block;
                            color: $ypo-blue;
                            font-size: 12px;
                            font-weight: bold;
                            line-height: 22px;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            overflow: hidden;

                            i {
                                width: 12px;
                                text-align: center;
                                margin-right: 10px;
                                color: $ypo-dark-background-gray
                            }
                        }
                    }

                    &__social {
                        padding-top: 10px;
                        align-items: center;
                        display: flex;

                        .disabled-item {
                            pointer-events: none;

                            i {
                                color: $ypo-medium-gray;
                                cursor: default;
                            }
                        }

                        i {
                            margin-right: 25px;
                            cursor: pointer;
                            color: $ypo-cta;
                            font-size: 24px;
                        }

                        i.email-icon {
                            font-size: 31px;
                        }
                    }
                }
            }
        }

        &__spelled {
            padding: 10px 20px;

            strong {
                display: block;
            }

            a {
                color: $ypo-cta;
                font-weight: 600;
            }

        }

        // Only for Ipad Pro
        @media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
            margin-top: 120px;
        }

        // Only for Ipad mini
        @media only screen and (min-width: 768px) and (max-height: 1024px) and (-webkit-min-device-pixel-ratio: 1.5) {
            margin-top: 120px;
        }

        @include breakpoint(sm) {
            .speakers-list {
                &__sorting {
                    .sort-options {
                        padding-left: 60px;
                        justify-content: right;
                        display: flex;

                        label {
                            left: 1px;
                        }
                    }
                }
            }
            &__find-speaker {
                .view-speaker {
                    margin: 8px;
                    display: block;
                }
            }

            .refine-list {
                padding-right: 0;

                .fee-range {
                    &__slider {
                        display: block !important;
                        padding: 0 5px;
                    }
                }
            }
            .view-speaker {
                margin: 8px;
            }
        }

        @include breakpoint(xs) {
            margin: 90px 15px 90px;

            .speakers-list {
                &__row {

                    .user-info,
                    .topics {
                        min-height: inherit;
                    }

                }

                &__sorting {
                    .sort-options {
                        padding-left: 60px;

                        label {
                            left: 1px;
                        }
                    }
                }
            }

            &__find-speaker {
                strong {
                    margin-top: 10px;
                    display: inline-block;
                }

                small {
                    display: block;
                    margin: 10px 0;
                }

                .success_btn {
                    margin-top: 15px;
                }

                .cff_btn {
                    margin-top: 15px;
                }

                .form-control {
                    margin-top: 15px;
                }

                .find-speaker-result {
                    width: 100%;
                    top: 65px;
                    min-width: inherit;
                }
                .view-speaker {
                    margin-top: 14px;
                    display: inherit;
                } 
            }
        }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .ypo-speakers {
        &__find-speaker {
            .form-control {
                .v-input__slot {
                    padding-right: 130px !important;
                    border: 1px solid rgba($ypo-gray, 0.4);
                    box-shadow: 0 1px 3px 0 rgba($black, 0.18) !important;
                    border-radius: 6px !important;

                    input {
                        font-size: 14px;
                        font-weight: 600;
                    }

                    i {
                        font-weight: 600;
                        color: $ypo-cta !important;
                        font-size: 18px;
                    }
                }
            }

            .success_btn {
                a {
                    text-decoration: none;
                }
            }
            .cff_btn {
                    background: $ypo-blue-secondary!important;
                    color: $white!important;
                    border-radius: 4px;
                    padding: 8px 28px;
                    min-width: inherit;
                    height: auto;
                    font-weight: 600;
                    box-shadow: none !important;
                    border: 1px solid $ypo-blue;

                    &.small {
                        padding: 5px 18px;
                    } 
                    
                    &.transparent {
                        background: none !important;
                    }

                    &.v-btn--outline {
                        border: 1px solid $ypo-dark-green !important;
                        color: $black !important;
                    }
                }

            .cff_btn {
                a {
                    text-decoration: none;
                }
            }

            .find-speaker-tooltip {
                left: 182px;
                top: 18px;

                @include breakpoint(xs) {
                    left: 70px;
                    top: 30px !important;
                }
            }
        }

        .refine-list {
            .form-control {
                label {
                    color: $ypo-blue;
                    font-size: 12px;
                    font-weight: 600;
                    display: block;
                }

                .v-input__control {
                    min-height: 38px;

                    .v-input__slot {
                        border: 1px solid $ypo-tile-border;
                        box-shadow: none;
                        border-radius: 3px;
                        font-size: 12px;
                        padding-left: 10px;

                        &::before {
                            border-color: inherit;
                        }
                    }

                }

                .v-chip {
                    background-color: $ypo-extra-light-gray;
                    border: 1px solid $ypo-cta;

                    .v-chip__content {
                        height: 28px;

                        i {
                            color: $ypo-cta !important;
                            opacity: inherit;
                        }
                    }
                }
            }

            .cff-fees {
                .form-control {
                    label {
                        color: $ypo-cta;
                    }

                    .v-select__slot {
                        label {
                            color: $ypo-cta;
                        }

                    }
                }

                &__column {
                    border-bottom: 1px solid rgba($ypo-gray, 0.4);
                }

                &__error {
                    border: 1px solid red;
                }
            }

            .ypo-region {
                .v-input__control {
                    min-height: 38px;

                    .v-input__slot {
                        border: 1px solid $ypo-tile-border;
                        box-shadow: none;
                        border-radius: 3px;
                        font-size: 12px;
                        padding-left: 10px;

                        &::before {
                            border-color: inherit;
                        }
                    }

                }
            }

            .select-topics {
                .v-expansion-panel {
                    box-shadow: none;

                    .v-expansion-panel__container {
                        background-color: transparent;
                        border-top: 0;

                        .v-expansion-panel__header {
                            color: $ypo-cta;
                            font-size: 12px;
                            font-weight: 600;
                            padding: 8px 5px;
                            transition: all 1s ease;

                            .v-icon {
                                font-weight: bold;
                                color: $ypo-blue !important;
                            }

                            &:hover {
                                background-color: rgba($ypo-dark-background-gray, 0.1);
                            }

                            .v-input {
                                display: inline-block;
                                margin-top: 0;

                                .v-icon {
                                    font-weight: 500;
                                    font-size: 16px;
                                }
                            }

                        }

                        .v-expansion-panel__body {
                            padding: 10px 10px 0 30px;

                            .v-card {
                                background-color: transparent;
                            }

                            .v-input__slot {
                                margin-bottom: 0;

                                .v-label {
                                    font-size: 12px;
                                    font-weight: 500;
                                    color: $ypo-gray-text !important;
                                }

                                .v-icon {
                                    font-size: 16px;
                                    color: $ypo-blue !important;
                                }
                            }
                        }

                        &.v-expansion-panel__container--active {
                            .v-expansion-panel__header {
                                background-color: rgba($ypo-dark-background-gray, 0.1);
                            }
                        }

                        &:nth-child(2n) {
                            background-color: $ypo-extra-light-gray;
                        }
                    }
                }

                &__title {
                    vertical-align: top;
                    display: inline-block;
                    padding-top: 4px;
                }
            }

            .fee-range {

                &__slider {
                    position: relative;
                    margin-top: 0;
                    padding-right: 28px;

                    .v-input__prepend-outer {
                        position: absolute;
                        left: 0;
                        top: 22px;

                        .v-input__control {
                            min-height: inherit;
                        }
                    }

                    .v-input__append-outer {
                        position: absolute;
                        right: 0;
                        top: 22px;

                        .v-input__control {
                            min-height: inherit;

                            input {
                                text-align: right;
                            }
                        }
                    }

                    .v-slider__track__container,
                    .v-slider__track,
                    .v-slider__track-fill {
                        height: 4px;

                        &:before {
                            height: 4px;
                        }
                    }

                    .v-slider__ticks-container {
                        cursor: pointer;
                    }

                    .v-slider__track-fill {
                        background-color: $ypo-dark-green !important;
                    }

                    .v-slider__thumb {
                        background-color: $ypo-cta !important;
                        cursor: pointer;
                    }

                    .v-input__control {
                        .v-input__slot {
                            padding: 0;
                            background-color: transparent;
                            font-size: 10px;

                            input {
                                color: $ypo-cta;
                                font-size: 12px;
                                padding: 0;
                            }

                            .v-slider__thumb-label__container {
                                .v-slider__thumb-label {
                                    border-radius: 3px;
                                    width: auto !important;
                                    height: auto !important;
                                    transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(0deg);

                                    &::after {
                                        content: "";
                                        width: 0;
                                        height: 0;
                                        border-top: 6px solid $ypo-blue;
                                        border-left: 6px solid transparent;
                                        border-right: 6px solid transparent;
                                        margin-top: 11px;
                                        position: absolute;
                                    }

                                    span {
                                        transform: rotate(0deg);
                                        padding: 0 5px 0 12px;

                                        &::before {
                                            content: "$";
                                            position: absolute;
                                            left: 4px;
                                            font-size: 11px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

        }

        .speakers-list {
            &__row {
                .topics {
                    .v-chip {
                        border: 1px solid $ypo-tile-border;
                        background-color: $white;

                        .v-chip__content {
                            height: auto;
                            color: $ypo-blue;
                            font-size: 12px;
                            font-weight: 600;
                            word-break: break-word;
                            line-height: normal;
                        }
                    }

                    em {
                        font-style: normal;
                        font-weight: 600;
                        color: $ypo-cta;
                        font-size: 11px;
                        cursor: pointer;
                        white-space: nowrap;
                    }

                }
            }
        }

        .find-speaker-tooltip {
            color: $white;
            position: absolute;
            background-color: $ypo-darker-gray-background;
            padding: 10px;
            font-size: 12px;
            -webkit-border-radius: 4px;
            -moz-border-radius: 4px;
            margin-top: 0;
            border-radius: 4px;
            min-width: 270px;
            max-width: 270px;
            z-index: 2;

            &__link {
                color: $white;
                font-weight: 600;
            }

        }
    }
</style>
